export default "__VITE_ASSET__Bbwr5lOa__"